// True when running inside the Tauri desktop app (vs the web build).
// Tauri injects window.__TAURI_INTERNALS__; it's absent in a browser, so any
// `invoke(...)` call there throws "Cannot read properties of undefined".
// Guard desktop-only features (Open in Claude, MCP registration, updater) with this.
export function isTauri(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}
